import { useEffect } from "react";
import "@/App.css";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AlertsProvider } from "@/context/AlertsContext";
import { unlockAudio, ensureNotifyPermission } from "@/lib/sound";
import TodoApp from "@/pages/TodoApp";
import { AuthPage } from "@/components/auth/AuthPage";

function AppGate() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <Loader2 className="w-7 h-7 text-primary animate-spin" />
      </div>
    );
  }

  if (!user) return <AuthPage />;

  return (
    <AlertsProvider>
      <TodoApp />
    </AlertsProvider>
  );
}

function App() {
  useEffect(() => {
    // Audio & Benachrichtigungen bei erster Interaktion freischalten (Browser-Policy)
    const unlock = () => {
      unlockAudio();
      ensureNotifyPermission();
      window.removeEventListener("pointerdown", unlock);
      window.removeEventListener("keydown", unlock);
    };
    window.addEventListener("pointerdown", unlock);
    window.addEventListener("keydown", unlock);
    return () => {
      window.removeEventListener("pointerdown", unlock);
      window.removeEventListener("keydown", unlock);
    };
  }, []);

  return (
    <AppProvider>
      <AuthProvider>
        <div className="App">
          <AppGate />
          <Toaster position="bottom-right" richColors />
        </div>
      </AuthProvider>
    </AppProvider>
  );
}

export default App;
